import React, { FunctionComponent, useContext } from "react"
import { DarkModeIconProps } from "./DarkModeIcon.models"
import { ThemeContext } from "../ThemeProvider"
import { MoonIcon, SunIcon } from "@radix-ui/react-icons"
import { Button } from "../Button.styles"

export const DarkModeIcon: FunctionComponent<DarkModeIconProps> = ({
  size,
  ...props
}) => {
  const { colorMode, setColorMode } = useContext(ThemeContext)
  const nextColorMode = colorMode === "light" ? "dark" : "light"

  return (
    <Button
      aria-label={`Change to ${nextColorMode} theme`}
      name="Toggle dark mode"
      variant="icon"
      onClick={() => setColorMode(nextColorMode)}
    >
      {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
    </Button>
  )
}
